// extracted by mini-css-extract-plugin
export default {"title":"s8M3BrbWISIe6n7jEScc","panelHeader":"uXI5B0GozjGvOSLVay8p"};